module.exports = __webpack_public_path__ + "img/icon-letter-y.5ae9274c.svg";